import SearchBtn from "../element/SearchBtn"

const SearchPanel = () => {

    return (
        <div className="search-panel">
            <SearchBtn label="Google Search"/>
            <SearchBtn label="I'm feeling Lucky"/>
        </div>
    );

};

export default SearchPanel;